import { useContext, useEffect, useState } from "react"
import { ItemsContext } from "../contexts/ItemsContext"
import { toast } from 'react-toastify'
import placeholders from "../helpers/placeholders"

const AddItem=()=>{

    const {addItem}=useContext(ItemsContext)
    const [title,setTitle]=useState("")
     const [details,setDetails]=useState("")
     const [index, setIndex] = useState(0)

     useEffect(() => {
        setIndex(index => (index + 1) % placeholders.length)

      }, [addItem])

    const handleSubmit=(e)=>{
        e.preventDefault()
        addItem(title,details)
        setTitle("")
        setDetails("")
        toast.success("The item has been SAVED")
        //setTimeout(()=>alert("The item has been SAVED."),100)    
    }

    return(
        <div className="form">
            <h2>Add a new item</h2>
            <form onSubmit={handleSubmit}>
                <label>Title: </label>
                <input 
                    type="text" 
                    placeholder={placeholders[index].title}
                    value={title}
                    onChange={(e)=>setTitle(e.target.value)}
                    required
                />
                <label>Details: </label>
                <textarea
                    placeholder={placeholders[index].body}
                    value={details}
                    onChange={(e)=>setDetails(e.target.value)}
                    required
                    cols="60" rows="4"
                />  
                <button>Save</button>
            </form>
        </div>
    )
}

export default AddItem